define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrStatusDomain = void 0;
    class SrStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: SrStatusDomain.Open, value: "Open" },
                    { key: SrStatusDomain.Conditional, value: "Conditional" },
                    { key: SrStatusDomain.Closed, value: "Closed" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[SrStatusDomain.Open] = 0;
                this.KeyIndex[SrStatusDomain.Conditional] = 1;
                this.KeyIndex[SrStatusDomain.Closed] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Open"] = 0;
                this.ValueIndex["Conditional"] = 1;
                this.ValueIndex["Closed"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.SrStatusDomain = SrStatusDomain;
    Object.defineProperty(SrStatusDomain, "Open", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Open"
    });
    Object.defineProperty(SrStatusDomain, "Conditional", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Conditional"
    });
    Object.defineProperty(SrStatusDomain, "Closed", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Closed"
    });
    Object.defineProperty(SrStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
